{
	"name": "wooden_door",
	"size": [32, 48],
	"kit": "old_wood",
	"parts": [
		{ "shape": "casing", "inset": [2, 1, 2, 0], "bevel": "left", "bevelWidth": 2 },
		{ "shape": "grille", "inset": [3, 2, 3, 1], "direction": "columns", "step": 7, "role": "grain" },
		{ "shape": "border", "inset": [5, 5, 5, 25], "role": "casing_shadow" },
		{ "shape": "panel", "inset": [6, 6, 6, 26], "role": "recess" },
		{ "shape": "border", "inset": [7, 7, 7, 27], "role": "grain_lit" },
		{ "shape": "border", "inset": [5, 25, 5, 5], "role": "casing_shadow" },
		{ "shape": "panel", "inset": [6, 26, 6, 6], "role": "recess" },
		{ "shape": "border", "inset": [7, 27, 7, 7], "role": "grain_lit" },
		{ "shape": "panel", "inset": [2, 22, 2, 24], "role": "casing_lit" },
		{ "shape": "panel", "inset": [2, 23, 2, 23], "role": "casing_shadow" },
		{ "shape": "panel", "inset": [2, 7, 26, 37], "role": "trim" },
		{ "shape": "panel", "inset": [2, 37, 26, 7], "role": "trim" },
		{ "shape": "studs", "inset": [3, 4, 26, 4], "along": "left", "step": 8, "size": [2, 2], "role": "trim_lit" },
		{
			"shape": "disc",
			"inset": [22, 20, 5, 21],
			"role": "brass",
			"borderRole": "trim_dark",
			"litRole": "brass_lit"
		},
		{ "shape": "panel", "inset": [24, 27, 6, 18], "role": "trim_dark" }
	]
}
